import { entity, list } from "./base";
import { concatModules } from "@/utility";

const initialEntity = {
  news_id: null,
  title: "",
  body: "",
  publish_at: null,
  published: 0,
  conditions: {},
  push_notification: 0
};

export const news = {
  namespaced: true,
  modules: {
    list: list("news"),
    entity: entity("news", initialEntity)
  }
};
